import More from "./More";
import MorePanel from "./MorePanel";

export default {
    button: More,
    name: "more",
    panel: MorePanel,
    panelClass: "more-panel",
};
